


































































import { Component, Prop, Vue, Provide } from 'vue-property-decorator';

import ErrorWrappedTextInput from '@/components/form-elements/ErrorWrappedTextInput.vue';
import AbstractAddItem_Step2 from '../AbstractAddItem-Step2.vue';


@Component({
  components: { ErrorWrappedTextInput }
})
export default class AddGenericItem_Step2 extends AbstractAddItem_Step2 {
}
